import React, { useState } from 'react';
import _ from 'lodash';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';

const CustomDropdown = ({
  column,
  data,
}) => {
  const [ isOpen, setIsOpen ] = useState(false);

  return (
    <Dropdown
      onMouseOver={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
      onClick={e => e.stopPropagation()}
    >
      <Dropdown.Toggle variant="success" id="dropdown-basic" onClick={e => e.stopPropagation()}>
        <FontAwesomeIcon icon={faEllipsisH}/>
      </Dropdown.Toggle>
      <Dropdown.Menu show={isOpen}>
        {column.items.map((item, index) => (
          <div
            key={index}
            className={`dropdown-item-list ${item.disabled ?
              item.disabled.func(...item.disabled.params.map((param) => _.get(data, param))) ? 'disabled'
              : ''
            : ''}`}
            onClick={() => item.action.func(...item.action.params.map((param) => _.get(data, param)))}
          >
            <span>{item.text}</span>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default CustomDropdown;